import { mount } from 'svelte';
import SimulateurNis2 from './nis2-simulateur/SimulateurNis2.svelte';

mount(SimulateurNis2, { target: document.getElementById('simulateur-nis2')! });
